
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/legal-judicial-advocacy/litigation-bulletin",
      function () {
        return require("private-next-pages/advocacy/legal-judicial-advocacy/litigation-bulletin/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/legal-judicial-advocacy/litigation-bulletin"])
      });
    }
  